import React, { useRef, useState, useEffect } from "react";
import styles from "./Pricing.module.css";
import RazorpayCheckout from "./RazorpayCheckout";
import ComparisonTable from "./ComparisonTable";
import AllTopUps from "./app_components/AllTopUps";
import { useTenantPlan } from "../hooks/useTenantPlan";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

function Pricing3() {
  const [billingCycle, setBillingCycle] = useState("monthly");
  // const [currentPlan, setCurrentPlan] = useState(null);
  // const [fullTenantData, setFullTenantData] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);
  const [exchangeRate, setExchangeRate] = useState(83);

  const {
    plan: currentPlan,
    data: fullTenantData,
    loading: planLoading,
    error: planError,
  } = useTenantPlan();

  console.log(currentPlan, "currentPlan and fullTenantData",fullTenantData);
  

  // Promo code states - plan-specific
  const [promoCodes, setPromoCodes] = useState({});
  const [appliedPromos, setAppliedPromos] = useState({});
  const [promoErrors, setPromoErrors] = useState({});
  const [promoSuccess, setPromoSuccess] = useState({});
  const [validatingPromos, setValidatingPromos] = useState({});
  const [showPromoInputs, setShowPromoInputs] = useState({});

  const comparisonRef = useRef(null);

  // Fetch current plan on component mount
  // useEffect(() => {
  //   const fetchCurrentPlan = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const response = await fetch(
  //         `https://mgmt-util2.${backend_api_base_url}/get_tenant_plan`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: token,
  //             "Content-Type": "application/json",
  //           },
  //         },
  //       );

  //       const data = await response.json();
  //       if (data.success) {
  //         setCurrentPlan(data.data.plan);
  //         setFullTenantData(data.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching current plan:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchCurrentPlan();
  // }, []);

  // Detect user location and fetch exchange rate
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        setUserLocation(data.country_code);
      })
      .catch(() => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const isLikelyUS =
          timezone.includes("America") || navigator.language.includes("en-US");
        setUserLocation(isLikelyUS ? "US" : "IN");
      });

    fetch("https://api.exchangerate-api.com/v4/latest/INR")
      .then((res) => res.json())
      .then((data) => {
        setExchangeRate(data.rates.USD || 83);
      })
      .catch(() => {
        setExchangeRate(83);
      });
  }, []);

  const scrollToComparison = () => {
    comparisonRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const getCurrentPlanDisplay = () => {
    if (!currentPlan) return null;
    const planDisplayMapping = {
      BASIC: "Launch 🚀",
      ADVANCE: "Starter 🌟",
      ADVANCE2: "Growth 🌱",
      ADVANCE3: "Scale ⚡",
      ADVANCE4: "Enterprise 🏢",
    };
    return planDisplayMapping[currentPlan] || currentPlan;
  };

  // Promo code validation function
  const validatePromoCode = async (planCode, amount) => {
    const currentPromoCode = promoCodes[planCode] || "";

    if (!currentPromoCode.trim()) {
      setPromoErrors((prev) => ({
        ...prev,
        [planCode]: "Please enter a promo code",
      }));
      return false;
    }

    setValidatingPromos((prev) => ({ ...prev, [planCode]: true }));
    setPromoErrors((prev) => ({ ...prev, [planCode]: "" }));
    setPromoSuccess((prev) => ({ ...prev, [planCode]: "" }));

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `https://mgmt-util2.${backend_api_base_url}/validate_promo_code`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            promo_code: currentPromoCode,
            plan_code: planCode,
            amount: amount,
          }),
        },
      );

      const data = await response.json();

      if (data.success) {
        if (data.data.valid) {
          const savings = amount - data.data.discounted_amount;

          setAppliedPromos((prev) => ({
            ...prev,
            [planCode]: data.data,
          }));

          setPromoSuccess((prev) => ({
            ...prev,
            [planCode]: `Promo code applied! You save ₹${savings.toLocaleString("en-IN")}`,
          }));
          setPromoErrors((prev) => ({ ...prev, [planCode]: "" }));
          setShowPromoInputs((prev) => ({ ...prev, [planCode]: false }));
          return true;
        } else {
          setPromoErrors((prev) => ({
            ...prev,
            [planCode]: data.data.message || "Invalid promo code",
          }));
          setAppliedPromos((prev) => {
            const newState = { ...prev };
            delete newState[planCode];
            return newState;
          });
          return false;
        }
      } else {
        setPromoErrors((prev) => ({
          ...prev,
          [planCode]: data.message || "Error validating promo code",
        }));
        setAppliedPromos((prev) => {
          const newState = { ...prev };
          delete newState[planCode];
          return newState;
        });
        return false;
      }
    } catch (error) {
      console.error("Error validating promo code:", error);
      setPromoErrors((prev) => ({
        ...prev,
        [planCode]: "Error validating promo code. Please try again.",
      }));
      setAppliedPromos((prev) => {
        const newState = { ...prev };
        delete newState[planCode];
        return newState;
      });
      return false;
    } finally {
      setValidatingPromos((prev) => ({ ...prev, [planCode]: false }));
    }
  };

  const removePromoCode = (planCode) => {
    setAppliedPromos((prev) => {
      const newState = { ...prev };
      delete newState[planCode];
      return newState;
    });
    setPromoCodes((prev) => ({ ...prev, [planCode]: "" }));
    setPromoSuccess((prev) => {
      const newState = { ...prev };
      delete newState[planCode];
      return newState;
    });
    setShowPromoInputs((prev) => ({ ...prev, [planCode]: false }));
  };

  const handlePromoCodeChange = (planCode, value) => {
    setPromoCodes((prev) => ({ ...prev, [planCode]: value.toUpperCase() }));
  };

  const togglePromoInput = (planCode, show) => {
    setShowPromoInputs((prev) => ({ ...prev, [planCode]: show }));
  };

  const planCodeMapping = {
    BASIC: "LAUNCH",
    ADVANCE: "STARTER",
    ADVANCE2: "GROWTH",
    ADVANCE3: "SCALE",
    ADVANCE4: "ENTERPRISE",
  };

  const planHierarchy = {
    LAUNCH: 0,
    STARTER: 1,
    GROWTH: 2,
    SCALE: 3,
    ENTERPRISE: 4,
  };

  const canPurchasePlan = (planCode) => {
    if (!currentPlan) return true;
    const currentPlanLevel = planHierarchy[planCodeMapping[currentPlan]];
    const targetPlanLevel = planHierarchy[planCode];
    return targetPlanLevel > currentPlanLevel;
  };

  const isCurrentPlan = (planCode) => {
    if (!currentPlan) return false;
    return planCodeMapping[currentPlan] === planCode;
  };

  // Pricing with profitability - AI messages ~2-3x MAU
  // Launch: ~2x MAU (break even / loss leader)
  // Starter: ~2.5x MAU (moderate margin)
  // Growth: ~3x MAU (good margin)
  // Scale: ~3x MAU (best margin)
  const pricingData = {
    monthly: {
      launch: 0,
      starter: 5999,
      growth: 14999,
      scale: 39999,
      enterprise: "Custom Pricing",
    },
    yearly: {
      launch: 0,
      starter: 57590,
      growth: 143990,
      scale: 383990,
      enterprise: "Contact Us",
    },
  };

  const plans = {
    monthly: [
      {
        type: "Launch 🚀",
        planCode: "LAUNCH",
        description: "Perfect for testing, MVPs & early-stage projects.",
        subheading: "Best for individuals exploring Sageion",
        features: [
          "✅ 50 AI Messages / month",
          "✅ 25 Monthly Active Users",
          "✅ 5MB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Lead capture with Q&A forms",
          "✅ Basic Email Notifications",
          "✅ Sageion branding",
          "✅ Export user data anytime (free)",
          "✅ Basic analytics dashboard",
        ],
        buttonLabel: "Get Started Free",
        cta: "Start Free",
        isFree: true,
      },
      {
        type: "Starter 🌟",
        planCode: "STARTER",
        description:
          "Complete customer communication suite for growing businesses.",
        subheading: "Best Value - 4-in-1 Platform",
        features: [
          "✅ 1,250 AI Messages / month",
          "✅ 500 Monthly Active Users",
          "✅ 50MB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Launch, plus:",
          "✅ Advance AI Models",
          "✅ Advanced lead capture forms with analytics",
          "✅ Custom email templates & automations",
          "✅ Advanced analytics dashboard",
          "✅ Remove Sageion branding",
          "✅ Priority email support",
          "✅ 30-day money-back guarantee",
        ],
        buttonLabel: "Choose Starter",
        cta: "Choose Starter",
      },
      {
        type: "Growth 🌱",
        planCode: "GROWTH",
        description:
          "For growing SaaS & SMBs with serious customer engagement needs.",
        subheading: "Most Popular - Best Value",
        features: [
          "✅ 7,500 AI Messages / month",
          "✅ 2,500 Monthly Active Users",
          "✅ 250MB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Starter, plus:",
          "✅ Advanced AI Models",
          "✅ Advanced analytics & reporting with exports",
          "✅ Priority Email & Chat Support",
          "✅ No Sageion branding",
          "✅ Full API Access with webhooks",
          "✅ Custom workflows & automations",
        ],
        buttonLabel: "Choose Growth",
        cta: "Choose Growth",
      },
      {
        type: "Scale ⚡",
        planCode: "SCALE",
        description:
          "For established companies, agencies, & high-traffic platforms.",
        subheading: "High-Volume Enterprise Solution",
        features: [
          "✅ 30,000 AI Messages / month",
          "✅ 10,000 Monthly Active Users",
          "✅ 1GB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Growth, plus:",
          "✅ Enterprise-grade AI with multi-model routing",
          "✅ Custom workflows & automations with visual builder",
          "✅ 5-year Chat History",
          "✅ SLA (99.9% uptime)",
          "✅ Phone & Dedicated Manager Support",
          "✅ Custom integration development support",
        ],
        buttonLabel: "Choose Scale",
        cta: "Choose Scale",
      },
      {
        type: "Enterprise 🏢",
        planCode: "ENTERPRISE",
        description:
          "For large enterprises with custom requirements & highest security.",
        subheading: "Fully Customizable Enterprise Solution",
        features: [
          "✅ Unlimited AI Messages",
          "✅ Unlimited Monthly Active Users",
          "✅ Custom Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Scale, plus:",
          "✅ Custom Knowledge Base Architecture",
          "✅ Custom Integrations (CRM, Helpdesk, ERP)",
          "✅ Personalized CSM & Engineering Support",
          "✅ Dedicated Onboarding & Training",
          "✅ Custom Workflow Development",
          "✅ 24/7 Priority Phone Support",
          "✅ Custom API Rate Limits & SLAs",
          "✅ Advanced Analytics Dashboard with BI integration",
          "✅ Multi-region Data Hosting",
          "✅ Custom AI model training",
          "✅ Audit logs & advanced security features",
          "✅ Quarterly business reviews",
        ],
        buttonLabel: "Contact Us",
        cta: "Schedule Demo",
        isEnterprise: true,
      },
    ],
    yearly: [
      {
        type: "Launch 🚀",
        planCode: "LAUNCH",
        description: "Perfect for testing, MVPs & early-stage projects.",
        subheading: "Best for individuals exploring Sageion",
        features: [
          "✅ 50 AI Messages / month",
          "✅ 25 Monthly Active Users",
          "✅ 5MB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Lead capture with Q&A forms",
          "✅ Basic Email Notifications",
          "✅ Sageion branding",
          "✅ Export user data anytime (free)",
          "✅ Basic analytics dashboard",
        ],
        buttonLabel: "Get Started Free",
        cta: "Start Free",
        isFree: true,
      },
      {
        type: "Starter 🌟",
        planCode: "STARTER",
        description:
          "Complete customer communication suite for growing businesses.",
        subheading: "Best Value - 4-in-1 Platform",
        features: [
          "✅ 1,250 AI Messages / month",
          "✅ 500 Monthly Active Users",
          "✅ 50MB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Launch, plus:",
          "✅ Enhanced AI Chat with smart replies",
          "✅ Advanced lead capture forms with analytics",
          "✅ Custom email templates & automations",
          "✅ Advanced analytics dashboard",
          "✅ Remove Sageion branding",
          "✅ Priority email support",
          "✅ 30-day money-back guarantee",
        ],
        buttonLabel: "Choose Starter",
        cta: "Choose Starter",
      },
      {
        type: "Growth 🌱",
        planCode: "GROWTH",
        description:
          "For growing SaaS & SMBs with serious customer engagement needs.",
        subheading: "Most Popular - Best Value",
        features: [
          "✅ 7,500 AI Messages / month",
          "✅ 2,500 Monthly Active Users",
          "✅ 250MB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Starter, plus:",
          "✅ Advanced AI with custom training & fine-tuning",
          "✅ Customizable Q&A trees + auto-email leads",
          "✅ Advanced analytics & reporting with exports",
          "✅ Priority Email & Chat Support",
          "✅ No Sageion branding",
          "✅ Full API Access with webhooks",
          "✅ Custom workflows & automations",
          "✅ Multi-language AI support",
        ],
        buttonLabel: "Choose Growth",
        cta: "Choose Growth",
      },
      {
        type: "Scale ⚡",
        planCode: "SCALE",
        description:
          "For established companies, agencies, & high-traffic platforms.",
        subheading: "High-Volume Enterprise Solution",
        features: [
          "✅ 30,000 AI Messages / month",
          "✅ 10,000 Monthly Active Users",
          "✅ 1GB Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Growth, plus:",
          "✅ Enterprise-grade AI with multi-model routing",
          "✅ Custom workflows & automations with visual builder",
          "✅ 5-year Chat History",
          "✅ SLA (99.9% uptime)",
          "✅ Phone & Dedicated Manager Support",
          "✅ Custom integration development support",
        ],
        buttonLabel: "Choose Scale",
        cta: "Choose Scale",
      },
      {
        type: "Enterprise 🏢",
        planCode: "ENTERPRISE",
        description:
          "For large enterprises with custom requirements & highest security.",
        subheading: "Fully Customizable Enterprise Solution",
        features: [
          "✅ Unlimited AI Messages",
          "✅ Unlimited Monthly Active Users",
          "✅ Custom Ingestion Storage",
          "✅ Unlimited Agents",
          "✅ Unlimited Websites",
          "✅ Everything in Scale, plus:",
          "✅ Custom Knowledge Base Architecture",
          "✅ Custom Integrations (CRM, Helpdesk, ERP)",
          "✅ Personalized CSM & Engineering Support",
          "✅ Dedicated Onboarding & Training",
          "✅ Custom Workflow Development",
          "✅ 24/7 Priority Phone Support",
          "✅ Custom API Rate Limits & SLAs",
          "✅ Advanced Analytics Dashboard with BI integration",
          "✅ Multi-region Data Hosting",
          "✅ Custom AI model training",
          "✅ Audit logs & advanced security features",
          "✅ Quarterly business reviews",
        ],
        buttonLabel: "Contact Us",
        cta: "Schedule Demo",
        isEnterprise: true,
      },
    ],
  };

  // Get price display
  const getPriceDisplay = (plan) => {
    if (plan.isFree) return "Free forever";
    if (plan.isEnterprise) return pricingData[billingCycle].enterprise;

    const priceData = pricingData[billingCycle][plan.planCode.toLowerCase()];
    const regularPrice = priceData;
    const regularDisplay = `₹${regularPrice.toLocaleString("en-IN")}/${billingCycle === "monthly" ? "month" : "year"}`;

    const planAppliedPromo = appliedPromos[plan.planCode];

    if (planAppliedPromo && planAppliedPromo.valid) {
      let discountedAmount;
      if (planAppliedPromo.discount_type === "fixed") {
        discountedAmount = regularPrice - planAppliedPromo.discount_amount;
      } else {
        discountedAmount =
          regularPrice * (1 - planAppliedPromo.discount_amount / 100);
      }

      return (
        <div className={styles.priceWithPromo}>
          <span className={styles.originalPrice}>{regularDisplay}</span>
          <span className={styles.discountedPrice}>
            ₹{Math.round(discountedAmount).toLocaleString("en-IN")}/
            {billingCycle === "monthly" ? "month" : "year"}
          </span>
        </div>
      );
    }

    return regularDisplay;
  };

  const getCheckoutPrice = (plan) => {
    if (plan.isFree || plan.isEnterprise) return 0;

    const priceData = pricingData[billingCycle][plan.planCode.toLowerCase()];
    const regularPrice = priceData;
    const planAppliedPromo = appliedPromos[plan.planCode];

    if (planAppliedPromo && planAppliedPromo.valid) {
      if (planAppliedPromo.discount_type === "fixed") {
        return Math.max(0, regularPrice - planAppliedPromo.discount_amount);
      } else {
        return Math.max(
          0,
          Math.round(
            regularPrice * (1 - planAppliedPromo.discount_amount / 100),
          ),
        );
      }
    }

    return regularPrice;
  };

  const getOriginalPrice = (plan) => {
    if (plan.isFree || plan.isEnterprise) return 0;
    return pricingData[billingCycle][plan.planCode.toLowerCase()];
  };

  const getUsdPrice = (plan) => {
    const inrPrice = getCheckoutPrice(plan);
    return (inrPrice / exchangeRate).toFixed(2);
  };

  const getValuePerUserText = (plan) => {
    if (plan.planCode === "STARTER") {
      const price = getCheckoutPrice(plan);
      const perUser =
        billingCycle === "monthly"
          ? (price / 500).toFixed(2)
          : (price / 12 / 500).toFixed(2);
      return `Premium features at ~₹${perUser} per user`;
    }
    if (plan.planCode === "GROWTH") {
      const price = getCheckoutPrice(plan);
      const per1000Messages = (price / (7500 / 1000)).toFixed(2);
      return `Enterprise-grade at ~₹${per1000Messages} per 1k messages`;
    }
    if (plan.planCode === "SCALE") {
      const price = getCheckoutPrice(plan);
      const per1000Messages = (price / (30000 / 1000)).toFixed(2);
      return `High-volume at ~₹${per1000Messages} per 1k messages`;
    }
    return null;
  };

  const isInternationalUser = userLocation && userLocation !== "IN";
  console.log("currentPlandddddd", currentPlan);
  return (
    <div className={styles.pricing3Page}>
      <AllTopUps tenantPlan={currentPlan} fullTenantData={fullTenantData} />

      <div className={styles.headingWrapper}>
        <h1>Pricing That Grows With You</h1>
        <p>
          Start free, scale as you grow. The Complete Customer Platform: AI +
          Live Chat + Auth Layer + Lead Capture.
        </p>

        {/* International Welcome Banner */}
        {isInternationalUser && (
          <div className={styles.internationalWelcome}>
            <div className={styles.welcomeContent}>
              <span className={styles.flag}>🌍</span>
              <div>
                <h4>Welcome International Customer!</h4>
                <p>
                  We accept payments in Indian Rupees (INR) via Razorpay. Your
                  bank will automatically convert to your local currency.
                  <a href="#faq"> Learn more about international payments</a>
                </p>
              </div>
            </div>
          </div>
        )}

        <div className={styles.curPlan_savCal_warp}>
          {currentPlan && !planLoading && (
            <div className={styles.currentPlanBanner}>
              <div className={styles.currentPlanContent}>
                <span className={styles.currentPlanName}>
                  {getCurrentPlanDisplay()}
                </span>
                <span className={styles.currentPlanLabel}>
                  Your Current Plan
                </span>
              </div>
            </div>
          )}
        </div>
        <div className={styles.valueBanner}>
          <div className={styles.valueItem}>
            <span className={styles.valueIcon}>🚀</span>
            <span>Complete Platform: AI + Live Chat + Auth + Leads</span>
          </div>
          <div className={styles.valueItem}>
            <span className={styles.valueIcon}>⚡</span>
            <span>No LLM Token Costs - Predictable Pricing</span>
          </div>
          <div className={styles.valueItem}>
            <span className={styles.valueIcon}>🏆</span>
            <span>60%+ Savings vs Piecemeal Solutions</span>
          </div>
        </div>
      </div>

      <div className={styles.tabsContainer}>
        <button
          className={`${styles.tabButton} ${
            billingCycle === "monthly" ? styles.activeTabButton : ""
          }`}
          onClick={() => setBillingCycle("monthly")}
        >
          Monthly
        </button>
        <button
          className={`${styles.tabButton} ${
            billingCycle === "yearly" ? styles.activeTabButton : ""
          }`}
          onClick={() => setBillingCycle("yearly")}
        >
          Yearly <span className={styles.saveBadge}>Best Value</span>
        </button>
      </div>

      <div className={styles.plansContainer}>
        {plans[billingCycle].map((plan, index) => {
          const isLaunch = plan.type.includes("Launch");
          const isStarter = plan.type.includes("Starter");
          const isGrowth = plan.type.includes("Growth");
          const isScale = plan.type.includes("Scale");
          const isEnterprise = plan.type.includes("Enterprise");

          const canPurchase = canPurchasePlan(plan.planCode);
          const isCurrent = isCurrentPlan(plan.planCode);
          const inrPrice = getCheckoutPrice(plan);
          const usdPrice = getUsdPrice(plan);

          // Get plan-specific promo states
          const planAppliedPromo = appliedPromos[plan.planCode];
          const planPromoError = promoErrors[plan.planCode];
          const planPromoSuccess = promoSuccess[plan.planCode];
          const planValidatingPromo = validatingPromos[plan.planCode];
          const planShowPromoInput = showPromoInputs[plan.planCode];
          const planPromoCode = promoCodes[plan.planCode] || "";

          return (
            <div
              key={index}
              className={`${styles.planCard} 
              ${isGrowth ? styles.highlight : ""} 
              ${isStarter ? styles.starter : ""}
              ${isLaunch ? styles.launch : ""}
              ${isScale ? styles.scale : ""}
              ${isEnterprise ? styles.enterprise : ""}
              ${isCurrent ? styles.currentPlan : ""}
              ${planAppliedPromo ? styles.hasPromo : ""}`}
            >
              <div className={styles.planHeader}>
                <h2 className={styles.planTitle}>{plan.type}</h2>
                {isGrowth && (
                  <span className={styles.popularBadge}>Most Popular</span>
                )}
                {isCurrent && (
                  <span className={styles.currentBadge}>Current Plan</span>
                )}
              </div>

              <p className={styles.planSubheading}>{plan.subheading}</p>

              <div>
                <div className={styles.priceContainer}>
                  {getPriceDisplay(plan)}
                </div>

                {/* USD Conversion for International Users */}
                {isInternationalUser && !plan.isFree && !plan.isEnterprise && (
                  <div className={styles.usdConversion}>
                    <span className={styles.usdPrice}>≈ ${usdPrice} USD</span>
                    <span className={styles.conversionNote}>
                      (Charged in INR, converted by your bank)
                    </span>
                  </div>
                )}

                {getValuePerUserText(plan) && (
                  <p className={styles.valuePerUser}>
                    {getValuePerUserText(plan)}
                  </p>
                )}
              </div>

              <p className={styles.planDescription}>{plan.description}</p>

              <ul className={styles.planFeatures}>
                {plan.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>

              {/* Promo Code Section - Show for non-free, non-enterprise plans */}
              {!plan.isFree && !plan.isEnterprise && (
                <div className={styles.promoCodeSection}>
                  {!planAppliedPromo ? (
                    <div className={styles.promoInputGroup}>
                      {planShowPromoInput ? (
                        <>
                          <div className={styles.promoInputWrapper}>
                            <input
                              type="text"
                              placeholder="Enter promo code"
                              value={planPromoCode}
                              onChange={(e) =>
                                handlePromoCodeChange(
                                  plan.planCode,
                                  e.target.value,
                                )
                              }
                              className={styles.promoInput}
                              disabled={planValidatingPromo}
                            />
                            <button
                              onClick={() =>
                                validatePromoCode(
                                  plan.planCode,
                                  getOriginalPrice(plan),
                                )
                              }
                              className={styles.applyPromoBtn}
                              disabled={
                                planValidatingPromo || !planPromoCode.trim()
                              }
                            >
                              {planValidatingPromo ? "..." : "Apply"}
                            </button>
                          </div>
                          {planPromoError && (
                            <span className={styles.promoError}>
                              {planPromoError}
                            </span>
                          )}
                          <button
                            onClick={() =>
                              togglePromoInput(plan.planCode, false)
                            }
                            className={styles.cancelPromoBtn}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => togglePromoInput(plan.planCode, true)}
                          className={styles.showPromoBtn}
                        >
                          Have a promo code? Click here
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className={styles.appliedPromo}>
                      <span className={styles.promoSuccess}>
                        {planPromoSuccess}
                      </span>
                      <button
                        onClick={() => removePromoCode(plan.planCode)}
                        className={styles.removePromoBtn}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* International Payment Notice */}
              {isInternationalUser &&
                !isCurrent &&
                canPurchase &&
                !isEnterprise &&
                !isLaunch && (
                  <div className={styles.internationalNotice}>
                    <div className={styles.noticeHeader}>
                      <span className={styles.noticeIcon}>ℹ️</span>
                      <span>Important for International Customers:</span>
                    </div>
                    <ul className={styles.noticePoints}>
                      <li>✅ Payment processed in Indian Rupees (INR)</li>
                      <li>✅ Your bank will convert to your local currency</li>
                      <li>✅ Most international cards accepted</li>
                      <li>⚠️ Small foreign transaction fee may apply (1-3%)</li>
                    </ul>
                  </div>
                )}

              {isCurrent ? (
                <button
                  className={`${styles.planButton} ${styles.currentPlanButton}`}
                  disabled
                >
                  Current Plan
                </button>
              ) : !canPurchase ? (
                <button
                  className={`${styles.planButton} ${styles.disabledButton}`}
                  disabled
                >
                  Upgrade to Higher Plan
                </button>
              ) : isEnterprise ? (
                <button
                  className={styles.planButton}
                  onClick={() => (window.location.href = "/contact")}
                >
                  {plan.cta}
                </button>
              ) : isScale ? (
                <RazorpayCheckout
                  cost={inrPrice}
                  planName={`Scale Plan - ${billingCycle === "monthly" ? "Monthly" : "Yearly"}`}
                  planCode="ADVANCE3"
                  buttonText={`Pay ₹${inrPrice.toLocaleString("en-IN")} in INR`}
                  disabled={!canPurchase}
                  showCurrencyInfo={true}
                  appliedPromo={planAppliedPromo}
                />
              ) : isGrowth ? (
                <RazorpayCheckout
                  cost={inrPrice}
                  planName={`Growth Plan - ${billingCycle === "monthly" ? "Monthly" : "Yearly"}`}
                  planCode="ADVANCE2"
                  buttonText={`Pay ₹${inrPrice.toLocaleString("en-IN")} in INR`}
                  disabled={!canPurchase}
                  showCurrencyInfo={true}
                  appliedPromo={planAppliedPromo}
                />
              ) : isStarter ? (
                <RazorpayCheckout
                  cost={inrPrice}
                  planName={`Starter Plan - ${billingCycle === "monthly" ? "Monthly" : "Yearly"}`}
                  planCode="ADVANCE"
                  buttonText={`Pay ₹${inrPrice.toLocaleString("en-IN")} in INR`}
                  disabled={!canPurchase}
                  showCurrencyInfo={true}
                  appliedPromo={planAppliedPromo}
                />
              ) : (
                <button
                  className={styles.planButton}
                  onClick={() => (window.location.href = "/signup")}
                >
                  {plan.buttonLabel}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* FAQ Section for International Payments */}
      <div className={styles.faqSection} id="faq">
        <h3>🌍 International Payment Information</h3>
        <div className={styles.faqGrid}>
          <div className={styles.faqItem}>
            <h4>Why am I charged in Indian Rupees (INR)?</h4>
            <p>
              We're an Indian company currently using Razorpay for payments,
              which processes transactions in INR. Your bank/card issuer will
              automatically convert the amount to your local currency.
            </p>
          </div>
          <div className={styles.faqItem}>
            <h4>Will there be extra fees?</h4>
            <p>
              Your bank may charge a small foreign transaction fee (typically
              1-3%). The exact conversion rate and fees are determined by your
              bank/card issuer.
            </p>
          </div>
          <div className={styles.faqItem}>
            <h4>Which cards are accepted?</h4>
            <p>
              Most international Visa, MasterCard, and American Express cards
              work. If your payment is declined, try contacting your bank to
              authorize international transactions.
            </p>
          </div>
          <div className={styles.faqItem}>
            <h4>Can I get a USD invoice?</h4>
            <p>
              Yes! After successful payment, email us at support@sageion.com
              with your transaction details, and we'll provide a proper USD
              invoice for your records.
            </p>
          </div>
          <div className={styles.faqItem}>
            <h4>Need help with payment?</h4>
            <p>
              Contact our support team at support@sageion.com or
              <a href="/contact"> use our contact form</a>. We're happy to help!
            </p>
          </div>
          <div className={styles.faqItem}>
            <h4>When will USD payments be available?</h4>
            <p>
              We're working on adding USD payment options.
              <a href="/updates"> Subscribe to updates</a> to be notified when
              this feature is available.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.seeAllButtonWrapper}>
        <button onClick={scrollToComparison}>
          See Full Feature Comparison
        </button>
      </div>

      <div ref={comparisonRef}>
        <ComparisonTable />
      </div>
    </div>
  );
}

export default Pricing3;
